var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChoice24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70002 4.65039H7.30002C5.84002 4.65039 4.65002 5.84039 4.65002 7.30039V8.70039C4.65002 10.1604 5.84002 11.3504 7.30002 11.3504H8.70002C10.16 11.3504 11.35 10.1604 11.35 8.70039V7.30039C11.35 5.84039 10.16 4.65039 8.70002 4.65039ZM9.65002 8.70039C9.65002 9.22039 9.22002 9.65039 8.70002 9.65039H7.30002C6.78002 9.65039 6.35002 9.22039 6.35002 8.70039V7.30039C6.35002 6.78039 6.78002 6.35039 7.30002 6.35039H8.70002C9.22002 6.35039 9.65002 6.78039 9.65002 7.30039V8.70039Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 4.65039H15.3C13.84 4.65039 12.65 5.84039 12.65 7.30039V8.70039C12.65 10.1604 13.84 11.3504 15.3 11.3504H16.7C18.16 11.3504 19.35 10.1604 19.35 8.70039V7.30039C19.35 5.84039 18.16 4.65039 16.7 4.65039ZM17.65 8.70039C17.65 9.22039 17.22 9.65039 16.7 9.65039H15.3C14.78 9.65039 14.35 9.22039 14.35 8.70039V7.30039C14.35 6.78039 14.78 6.35039 15.3 6.35039H16.7C17.22 6.35039 17.65 6.78039 17.65 7.30039V8.70039Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70002 12.6504H7.30002C5.84002 12.6504 4.65002 13.8404 4.65002 15.3004V16.7004C4.65002 18.1604 5.84002 19.3504 7.30002 19.3504H8.70002C10.16 19.3504 11.35 18.1604 11.35 16.7004V15.3004C11.35 13.8404 10.16 12.6504 8.70002 12.6504ZM9.65002 16.7004C9.65002 17.2204 9.22002 17.6504 8.70002 17.6504H7.30002C6.78002 17.6504 6.35002 17.2204 6.35002 16.7004V15.3004C6.35002 14.7804 6.78002 14.3504 7.30002 14.3504H8.70002C9.22002 14.3504 9.65002 14.7804 9.65002 15.3004V16.7004Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.3504C17.8502 19.3504 19.35 17.8505 19.35 16.0004C19.35 14.1502 17.8502 12.6504 16 12.6504C14.1499 12.6504 12.65 14.1502 12.65 16.0004C12.65 17.8505 14.1499 19.3504 16 19.3504Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChoice24Line);
export default __webpack_public_path__ + "static/media/icon_choice_24_line.28d02a8cae8537c65f285acac6fa797f.svg";
export { ForwardRef as ReactComponent };